export default {
  name: 'Aempty',
  props: {
    image: { type: String, default: () => '' },
    imageSize: { type: Number, default: () => 100 },
    description: { type: String, default: () => '暂无数据' },
  },
  render() {
    const { ...attrs } = this.$attrs;
    return (
      <el-empty class="a-empty" image={this.image} image-size={this.imageSize} description={this.description} {...{ attrs }}>
        {this.$slots.default}
      </el-empty>
    );
  }
}